const indexInit = {
    
}
const qipao = (state = indexInit, action) => {
    switch (action.type) {
      case "QIPAO_LST":
        return Object.assign({}, state, {
          ...action
        });
      case "QIPAO_ARTICLE":
        return Object.assign({}, state, {
          ...action
        });
      default:
        return state;
    }
}

export default qipao